import React, { Component } from 'react'
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import {  configTeamLeaderProspectMonitoringTeam } from '../config'

export default class TeamLeaderProspectReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: configTeamLeaderProspectMonitoringTeam,
    };
  }

  render() {
    return (
      <div style={{ padding: 10 }}>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN STATISTIK PROSPEK PER TEAM LEADER
        </p>
        <SimpleDataTable
          data={this.props.dataTable}
          columns={configTeamLeaderProspectMonitoringTeam}
        />
      </div>
    );
  }
}
